export const canUseOrdersRecognitionWithAi =
    window.appPermissions?.canUseOrdersRecognitionWithAi === true;
